// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedback-form-container {
    background: #f5f5f5;
    min-height: 100vh;
}

.logo-img {
    max-width: 200px;
    margin: 20px auto;
}

.feedback-card {
    background: #fff;
    border-radius: 8px;
    padding: 30px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.form-header {
    text-align: center;
    border-bottom: 2px solid #eee;
    padding-bottom: 20px;
    margin-bottom: 30px;
}

.form-title {
    color: #333;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 15px;
}

.form-description {
    color: #666;
    font-size: 16px;
    line-height: 1.6;
    white-space: pre-line;
    margin: 0;
    padding: 0 15px;
}

.questions-container {
    padding: 20px 0;
}

.submit-section {
    text-align: center;
    margin-top: 30px;
    padding-top: 20px;
    border-top: 2px solid #eee;
}

.rating-container {
    display: flex;
    gap: 10px;
    justify-content: start;
    margin: 15px 0;
}

.rating-container {
    display: flex;
    align-items: center;
    margin: 10px 0;
}

.star-btn {
    background: none;
    border: none;
    padding: 5px;
    cursor: pointer;
    font-size: 24px;
    transition: transform 0.2s;
}

.star-btn:hover {
    transform: scale(1.1);
}

.star-filled {
    color: #ffc107;
}

.star-empty {
    color: #e4e5e9;
}

.rating-text {
    font-size: 14px;
    color: #666;
}

.rating-btn {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    border: 2px solid #0d6efd;
    background: white;
    color: #0d6efd;
    font-weight: 600;
    transition: all 0.3s ease;
}

.rating-btn:hover,
.rating-btn:focus {
    background: #0d6efd;
    color: white;
}

.rate_container {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.experienceboxheading {
    text-align: center;
    margin-bottom: 30px;
}

.experienceboxheading h3 {
    color: #333;
    margin-bottom: 15px;
}

.form-label {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin-bottom: 10px;
}

.text-danger {
    color: #dc3545;
    font-size: 0.875em;
    margin-top: 0.25rem;
}

.rating-wrapper {
    position: relative;
    margin-bottom: 1rem;
}

.rating-hidden-input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}

.star-btn.error .star-empty {
    color: #dc3545;
}

.invalid-feedback {
    color: #dc3545;
    font-size: 0.875em;
    margin-top: 0.25rem;
}

.free-text-wrapper,
.radio-wrapper {
    position: relative;
    margin-bottom: 1rem;
}

.form-control.is-invalid,
.radio-options.is-invalid {
    border-color: #dc3545;
}

.form-control.is-invalid:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.radio-options.is-invalid .form-check-input {
    border-color: #dc3545;
}

.mb-4.has-error .form-control,
.mb-4.has-error .radio-options,
.mb-4.has-error .rating-container {
    border-color: #dc3545;
}

.mb-4.has-error .star-btn .star-empty {
    color: #dc3545;
}

.experienceboxheading {
    background: #0b3454;
    border-radius: 4px 4px 0 0;
    min-height: 173px;
    padding: 30px 40px;
    position: relative;
    overflow: hidden;
}
.experienceboxheading:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 131px;
    background: url(https://crm.univariety.xyz/images/left_img.png) no-repeat left bottom / cover;
}
.experienceboxheading::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 84px;
    background: url(https://crm.univariety.xyz/images/right_img.png) no-repeat left bottom / cover;
}
.experienceboxheading h3 {
    font-size: 24px;
    line-height: 26px;
    margin-bottom: 10px;
    text-align: center;
    color: #fff;
    position: relative;
}
.experienceboxheading p {
    font-size: 16px;
    line-height: 23px;
    text-align: center;
    color: #fff;
    margin: 0;
    position: relative;
}

@media (max-width: 767px) {
    .experienceboxheading::before {
        left: -20px;
    }
    .experienceboxheading::after {
        right: -20px;
    }
}
@media (max-width: 575px) {
    .experienceboxheading::before,
    .experienceboxheading::after {
        opacity: 0.5;
    }
    .experienceboxheading p br {
        display: none;
    }
}

.formtype-preview .star-btn {
    opacity: 0.5;
    cursor: not-allowed;
}

:disabled {
    cursor: not-allowed;
    
}
input[type="radio"]:disabled {
    cursor: not-allowed;
    opacity: 0.5;  /* Optional for visual feedback */
}`, "",{"version":3,"sources":["webpack://./src/features/feedback/feedback.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;;IAEI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,iDAAiD;AACrD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,YAAY;IACZ,6FAA6F;AACjG;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,QAAQ;IACR,WAAW;IACX,8FAA8F;AAClG;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,YAAY;IAChB;AACJ;AACA;IACI;;QAEI,YAAY;IAChB;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;;AAEvB;AACA;IACI,mBAAmB;IACnB,YAAY,GAAG,iCAAiC;AACpD","sourcesContent":[".feedback-form-container {\n    background: #f5f5f5;\n    min-height: 100vh;\n}\n\n.logo-img {\n    max-width: 200px;\n    margin: 20px auto;\n}\n\n.feedback-card {\n    background: #fff;\n    border-radius: 8px;\n    padding: 30px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.form-header {\n    text-align: center;\n    border-bottom: 2px solid #eee;\n    padding-bottom: 20px;\n    margin-bottom: 30px;\n}\n\n.form-title {\n    color: #333;\n    font-size: 24px;\n    font-weight: 600;\n    margin-bottom: 15px;\n}\n\n.form-description {\n    color: #666;\n    font-size: 16px;\n    line-height: 1.6;\n    white-space: pre-line;\n    margin: 0;\n    padding: 0 15px;\n}\n\n.questions-container {\n    padding: 20px 0;\n}\n\n.submit-section {\n    text-align: center;\n    margin-top: 30px;\n    padding-top: 20px;\n    border-top: 2px solid #eee;\n}\n\n.rating-container {\n    display: flex;\n    gap: 10px;\n    justify-content: start;\n    margin: 15px 0;\n}\n\n.rating-container {\n    display: flex;\n    align-items: center;\n    margin: 10px 0;\n}\n\n.star-btn {\n    background: none;\n    border: none;\n    padding: 5px;\n    cursor: pointer;\n    font-size: 24px;\n    transition: transform 0.2s;\n}\n\n.star-btn:hover {\n    transform: scale(1.1);\n}\n\n.star-filled {\n    color: #ffc107;\n}\n\n.star-empty {\n    color: #e4e5e9;\n}\n\n.rating-text {\n    font-size: 14px;\n    color: #666;\n}\n\n.rating-btn {\n    width: 45px;\n    height: 45px;\n    border-radius: 50%;\n    border: 2px solid #0d6efd;\n    background: white;\n    color: #0d6efd;\n    font-weight: 600;\n    transition: all 0.3s ease;\n}\n\n.rating-btn:hover,\n.rating-btn:focus {\n    background: #0d6efd;\n    color: white;\n}\n\n.rate_container {\n    background: #fff;\n    border-radius: 8px;\n    padding: 20px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.experienceboxheading {\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.experienceboxheading h3 {\n    color: #333;\n    margin-bottom: 15px;\n}\n\n.form-label {\n    font-size: 16px;\n    font-weight: 500;\n    color: #333;\n    margin-bottom: 10px;\n}\n\n.text-danger {\n    color: #dc3545;\n    font-size: 0.875em;\n    margin-top: 0.25rem;\n}\n\n.rating-wrapper {\n    position: relative;\n    margin-bottom: 1rem;\n}\n\n.rating-hidden-input {\n    position: absolute;\n    opacity: 0;\n    pointer-events: none;\n}\n\n.star-btn.error .star-empty {\n    color: #dc3545;\n}\n\n.invalid-feedback {\n    color: #dc3545;\n    font-size: 0.875em;\n    margin-top: 0.25rem;\n}\n\n.free-text-wrapper,\n.radio-wrapper {\n    position: relative;\n    margin-bottom: 1rem;\n}\n\n.form-control.is-invalid,\n.radio-options.is-invalid {\n    border-color: #dc3545;\n}\n\n.form-control.is-invalid:focus {\n    border-color: #dc3545;\n    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);\n}\n\n.radio-options.is-invalid .form-check-input {\n    border-color: #dc3545;\n}\n\n.mb-4.has-error .form-control,\n.mb-4.has-error .radio-options,\n.mb-4.has-error .rating-container {\n    border-color: #dc3545;\n}\n\n.mb-4.has-error .star-btn .star-empty {\n    color: #dc3545;\n}\n\n.experienceboxheading {\n    background: #0b3454;\n    border-radius: 4px 4px 0 0;\n    min-height: 173px;\n    padding: 30px 40px;\n    position: relative;\n    overflow: hidden;\n}\n.experienceboxheading:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 131px;\n    background: url(https://crm.univariety.xyz/images/left_img.png) no-repeat left bottom / cover;\n}\n.experienceboxheading::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    width: 84px;\n    background: url(https://crm.univariety.xyz/images/right_img.png) no-repeat left bottom / cover;\n}\n.experienceboxheading h3 {\n    font-size: 24px;\n    line-height: 26px;\n    margin-bottom: 10px;\n    text-align: center;\n    color: #fff;\n    position: relative;\n}\n.experienceboxheading p {\n    font-size: 16px;\n    line-height: 23px;\n    text-align: center;\n    color: #fff;\n    margin: 0;\n    position: relative;\n}\n\n@media (max-width: 767px) {\n    .experienceboxheading::before {\n        left: -20px;\n    }\n    .experienceboxheading::after {\n        right: -20px;\n    }\n}\n@media (max-width: 575px) {\n    .experienceboxheading::before,\n    .experienceboxheading::after {\n        opacity: 0.5;\n    }\n    .experienceboxheading p br {\n        display: none;\n    }\n}\n\n.formtype-preview .star-btn {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n:disabled {\n    cursor: not-allowed;\n    \n}\ninput[type=\"radio\"]:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;  /* Optional for visual feedback */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
